import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMyBodyMeasurementsGraph, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { MY_BODY_MEASUREMENTS_GRAPH_GET, MY_BODY_MEASUREMENTS_UPDATE } from '../new';

import { useEffectOnSuccess } from '.';

const useUserMeasurementsGraph = () => {
  const dispatch = useDispatch();
  const myBodyMeasurementsGraph = useSelector(state => state.userTrainingInfo.myBodyMeasurementsGraph);

  useEffect(() => {
    if (myBodyMeasurementsGraph.status === StateStatus.NOT_INITIALIZED) {
      dispatch(getMyBodyMeasurementsGraph());
    }
  }, [dispatch, myBodyMeasurementsGraph.status]);

  useEffectOnSuccess([state => state.userTrainingInfo.updateMyBodyMeasurements], () => {
    dispatch(resetState(MY_BODY_MEASUREMENTS_GRAPH_GET));
    dispatch(resetState(MY_BODY_MEASUREMENTS_UPDATE));
  });

  return myBodyMeasurementsGraph;
};

export default useUserMeasurementsGraph;
